export const environment = {
  production: true,
  configRequestUrl: '/config.json',
  platform: 'Web',
};
